import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { ChatChannelAccessTypeEnum } from '@smarttask-common/src/lib/models/Chat/Channel/Enums/ChatChannelAccessTypeEnum';
import { ChatChannelCollaboratorModel } from '@smarttask-common/src/lib/models/Chat/Channel/ChatChannelCollaboratorModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class ChatHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.chat_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.chat_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.chat_channel_new, (channel_id: string, for_user_ids: number[]) => {
            this.broadcast(SharedEventNameEnum.chat_channel_new, { channel_id, for_user_ids });
        });

        this.on(SharedEventNameEnum.chat_channel_name_update, (channel_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.chat_channel_name_update, { channel_id, name });
        });

        this.on(SharedEventNameEnum.chat_channel_access_update, (channel_id: string, access_type: ChatChannelAccessTypeEnum) => {
            this.broadcast(SharedEventNameEnum.chat_channel_access_update, { channel_id, access_type });
        });

        this.on(SharedEventNameEnum.chat_channel_delete, (channel_id: string) => {
            this.broadcast(SharedEventNameEnum.chat_channel_delete, { channel_id });
        });

        this.on(SharedEventNameEnum.chat_channel_collaborators_upsert, (channel_id: string, users: ChatChannelCollaboratorModel[]) => {
            this.broadcast(SharedEventNameEnum.chat_channel_collaborators_upsert, { channel_id, users });
        });

        this.on(SharedEventNameEnum.chat_channel_collaborators_remove, (channel_id: string, user_ids: number[]) => {
            this.broadcast(SharedEventNameEnum.chat_channel_collaborators_remove, { channel_id, user_ids });
        });

        this.on(SharedEventNameEnum.chat_channel_message_upsert, (channel_id: string, message_id: string) => {
            this.broadcast(SharedEventNameEnum.chat_channel_message_upsert, { channel_id, message_id });
        });

        this.on(SharedEventNameEnum.chat_channel_message_reaction, (channel_id: string, message_id: string, by_user_id: number, emoji: string) => {
            this.broadcast(SharedEventNameEnum.chat_channel_message_reaction, { channel_id, message_id, by_user_id, emoji });
        });

        this.on(SharedEventNameEnum.chat_channel_message_delete, (channel_id: string, message_id: string) => {
            this.broadcast(SharedEventNameEnum.chat_channel_message_delete, { channel_id, message_id });
        });
    };
}
